import { useMediaQuery, useTheme } from '@mui/material';
import ClipExportDialog from '@components/dialogs/ClipExportDialog';
import { useClipExportController } from './useClipExportController';

export default function ClipExportDialogController({ open, onClose, episode }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const viewModel = useClipExportController({ episode, isMobile, onClose });

  return (
    <ClipExportDialog
      open={open}
      onClose={onClose}
      episode={episode}
      isMobile={isMobile}
      {...viewModel}
    />
  );
}
